import React, { useEffect, useState } from 'react';
import { API_BASE_URL } from '../config';

function getAuthHeaders(extra = {}) {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}`, ...extra } : extra;
}

function getConfidenceLabel(confidence) {
  const c = String(confidence || 'low').toLowerCase();
  if (c === 'high') return 'Yüksek';
  if (c === 'medium') return 'Orta';
  return 'Düşük';
}

export default function HealthMedicalNotice({
  enabled = false,
  targetMemberKey = 'household',
  className = ''
}) {
  const [loading, setLoading] = useState(false);
  const [doctorReferralRequired, setDoctorReferralRequired] = useState(false);
  const [criticalFlag, setCriticalFlag] = useState(false);
  const [confidence, setConfidence] = useState('low');
  const [confidenceScore, setConfidenceScore] = useState(null);

  useEffect(() => {
    let mounted = true;
    if (!enabled) {
      setDoctorReferralRequired(false);
      setCriticalFlag(false);
      return undefined;
    }

    (async () => {
      try {
        setLoading(true);
        const res = await fetch(
          `${API_BASE_URL}/api/health/profile?targetMemberKey=${encodeURIComponent(targetMemberKey || 'household')}`,
          {
            credentials: 'include',
            headers: getAuthHeaders()
          }
        );
        const data = await res.json().catch(() => ({}));
        if (!res.ok || !mounted) return;

        const profile = data.profile || {};
        const normalizedProfile = data.normalizedProfile || profile.normalizedProfile || {};
        const confidenceMeta = normalizedProfile.confidenceMeta || {};

        setDoctorReferralRequired(!!(data.doctorReferralRequired ?? profile.doctorReferralRequired));
        setCriticalFlag(!!(data.criticalFlag ?? profile.criticalFlag));
        setConfidence(String(profile.confidence || confidenceMeta.tier || 'low').toLowerCase());
        setConfidenceScore(
          Number.isFinite(Number(confidenceMeta.score)) ? Number(confidenceMeta.score) : null
        );
      } catch (error) {
        console.warn('health medical notice fetch warning', error);
      } finally {
        if (mounted) setLoading(false);
      }
    })();

    return () => {
      mounted = false;
    };
  }, [enabled, targetMemberKey]);

  if (!enabled || loading) return null;

  return (
    <div className={`space-y-2 ${className}`}>
      {doctorReferralRequired && (
        <div className="rounded-2xl border border-amber-300 bg-amber-50 px-4 py-3 text-amber-900 dark:border-amber-800 dark:bg-amber-900/20 dark:text-amber-200">
          <p className="text-xs font-black uppercase tracking-[0.14em]">Sağlık Uyarısı</p>
          <p className="mt-1 text-sm font-semibold">
            Değerlerin için doktoruna danışman faydalı olabilir. Bu öneriler tıbbi tanı/tedavi yerine geçmez.
          </p>
        </div>
      )}

      {!doctorReferralRequired && criticalFlag && (
        <div className="rounded-2xl border border-red-300 bg-red-50 px-4 py-3 text-red-900 dark:border-red-800 dark:bg-red-900/20 dark:text-red-200">
          <p className="text-xs font-black uppercase tracking-[0.14em]">Dikkat</p>
          <p className="mt-1 text-sm font-semibold">
            Kritik eşik sinyali algılandı. Lütfen profesyonel sağlık desteği al.
          </p>
        </div>
      )}

      <div className="rounded-2xl border border-blue-200 bg-blue-50 px-4 py-3 text-blue-900 dark:border-blue-800 dark:bg-blue-900/20 dark:text-blue-200">
        <p className="text-xs font-black uppercase tracking-[0.14em]">Sağlık+ Güven Seviyesi</p>
        <p className="mt-1 text-sm font-semibold">
          {getConfidenceLabel(confidence)}
          {confidenceScore !== null ? ` (${Math.round(confidenceScore * 100)}%)` : ''}
        </p>
      </div>
    </div>
  );
}

